<template>
  <a-modal
    title="批量添加用户"
    :maskClosable="false"
    :visible="visible"
    width="700px"
    okText="保存"
    @ok="onSave"
    @cancel="handleClose"
  >
    <div class="content">
      <a-transfer
        :list-style="{
          width: '300px',
          height: '400px',
        }"
        :data-source="notExistList"
        show-search
        :titles="['不在该角色用户', '已在该角色用户']"
        :filter-option="filterOption"
        :target-keys="existList"
        :render="(item) => item.title"
        @change="handleChange"
        @search="handleSearch"
      />
    </div>
  </a-modal>
</template>
<script>
import { addBindUsers } from "./service";
export default {
  props: {
    existList: {
      type: Array,
    },
    notExistList: {
      type: Array,
    },
    dataSource: {
      type: Array,
    },
  },
  data() {
    return {
      visible: false,
      modalRecord: {},
      removeIds: [],
      addUserList: [],
    };
  },
  mounted() {},
  methods: {
    openBatchCreatingModal(record) {
      this.visible = true;
      this.modalRecord = record;
      console.log("record", this.modalRecord);
    },
    handleClose() {
      this.visible = false;
      this.modalRecord = {};
    },
    async onSave() {
      try {
        const params = {
          authRoleId: this.modalRecord.id,
        };
        if (this.removeIds.length !== 0) {
          params.removeIdList = this.removeIds;
        }
        if (this.addUserList.length !== 0) {
          params.memberRoleList = this.addUserList;
        }

        const res = await addBindUsers.request(params);

        if (res.bizCode === 1) {
          this.$message.success("操作成功", 4);
          this.handleClose();
          this.$emit("getDataList");
        }
      } catch (error) {
        console.log(error);
      }
    },
    filterOption(inputValue, option) {
      return option.title.indexOf(inputValue) > -1;
    },
    handleChange(targetKeys, direction, moveKeys) {
      console.log(targetKeys, direction, moveKeys);
      this.existList = targetKeys;
      if (direction === "left") {
        let ids = [];
        moveKeys.map((value) => {
          this.dataSource.map((item) => {
            if (value === item.memberId) {
              ids.push(item.id);
            }
          });
        });
        this.removeIds = ids;
      }
      let list = [];
      targetKeys.map((value) => {
        let obj = {
          memberId: value,
        };
        this.dataSource.map((item) => {
          if (this.removeIds.includes(item.id) && direction === "right") {
            this.removeIds = this.removeIds.filter(
              (value) => value !== item.id
            );
          }
          if (value === item.memberId && item.id) {
            obj.id = item.id;
          }
        });
        list.push(obj);
      });
      this.addUserList = list;
      console.log("removeIds", this.removeIds);
      console.log("list", list);
    },
    handleSearch(dir, value) {
      console.log("search:", dir, value);
    },
  },
};
</script>
<style lang="less" scoped></style>
